import { GridColDef, isAutogeneratedRow } from "@mui/x-data-grid-premium";
import { DocumentListItemDTO } from "../../types/DocumentListItemDTO";
import DocumentStatusChip from "../documents/DocumentStatusChip";
import { formatCurrencyAmount } from "../../utils/formatters";
import { formatDateToDDMMYYYY } from "../../utils/dateFormetter";
import { withCaseInsensitiveStringFilters } from "../../utils/stringFilterOperators";
import { getDocumentStatusOptions } from "../../constants/statusFilterOptions";

export const createVendorDocumentColumns = (
  t: (key: string, options?: any, ns?: any) => string
): GridColDef<DocumentListItemDTO>[] => [
  withCaseInsensitiveStringFilters({
    field: "number",
    headerName: t("number"),
    flex: 1.4,
    sortable: true,
    filterable: true,
    aggregable: false,
  }) as GridColDef<DocumentListItemDTO>,

  {
    field: "documentDate",
    headerName: t("documentDate"),
    flex: 1,
    sortable: true,
    filterable: true,
    aggregable: false,
    type: "date",

    valueGetter: (value, row) => {
      if (isAutogeneratedRow(row)) {
        return null;
      }

      if (!value) {
        return null;
      }

      return new Date(value);
    },

    valueFormatter: (value) => {
      if (!value) {
        return "—";
      }

      return formatDateToDDMMYYYY(value);
    },
  },

  {
    field: "amountGross",
    headerName: t("amountGross"),
    flex: 1,
    type: "number",
    width: 150,
    sortable: true,
    filterable: true,
    aggregable: true,
    availableAggregationFunctions: ["sum", "avg", "min", "max"],
    align: "right",
    headerAlign: "right",

    valueGetter: (_value, row) =>
      isAutogeneratedRow(row) ? undefined : row.amountGross,

    valueFormatter: (value) =>
      value === undefined || value === null
        ? ""
        : formatCurrencyAmount(value),
  },

  withCaseInsensitiveStringFilters({
    field: "currency",
    headerName: t("currency"),
    sortable: true,
    filterable: true,
    aggregable: false,

    valueGetter: (_value, row) =>
      isAutogeneratedRow(row) ? "" : row.currency,

    renderCell: (params) =>
      isAutogeneratedRow(params.row) ? null : <>{params.row.currency}</>,
  }) as GridColDef<DocumentListItemDTO>,

  {
    field: "status",
    headerName: t("status"),
    type: "singleSelect",
    flex: 1,
    sortable: true,
    filterable: true,
    aggregable: false,

    valueOptions: getDocumentStatusOptions(t),

    valueGetter: (_value, row) =>
      isAutogeneratedRow(row) ? undefined : row.status,

    valueFormatter: (value) =>
      value ? t(value, {}, "statuses") : "",

    renderCell: (params) =>
      isAutogeneratedRow(params.row) ? null : (
        <DocumentStatusChip status={params.row.status} />
      ),
  },
];